import * as React from 'react';
import moment from 'moment';
import { Link as LinkType } from '../../../typings';
import './styles.scss';

interface DateAndCategoryProps {
  date?: string;
  category?: LinkType;
  dateFormat?: string;
}

const DateAndCategory = ({ date, category, dateFormat }: DateAndCategoryProps) => (
  <div className="date-and-category">
    {category && (
      <div className="date-and-category__category">
        <a href={category.url}>{category.title}</a>
      </div>
    )}
    {date && (
      <time className="date-and-category__date" dateTime={date}>
        {!dateFormat && date}
        {dateFormat && moment(date).format(dateFormat)}
      </time>
    )}

  </div>
);

export default DateAndCategory;
